import { gql, useApolloClient } from '@apollo/client';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { ButtonLargeWhite, StyledLink } from '../../styles/theme/default/default';

const Wrapper = styled.div`
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .notfound {
    font-family: ${({ theme }) => theme.fonts.secondary.family};
    letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
    font-style: normal;
    font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
    font-size: 45px;
    line-height: 55px;
    text-align: center;
    color: ${({ theme }) => theme.colors.charcoal};
  }
  button {
    width: 312px;
    height: 46px;
    position: relative;
    background: ${({ theme }) => theme.colors.limoncello};
    margin-bottom: 50px;
    margin-top: 40px;
    &:hover {
      border: 1px solid #2a5caf;
    }
    a {
      position: absolute;
      top: 0;
      right: 0;
      font-family: ${({ theme }) => theme.fonts.primary};
      font-style: normal;
      font-weight: 500;
      font-size: 21px;
      line-height: 25px;
      text-align: center;
      letter-spacing: 0.07px;
      color: #ffffff;
    }
  }

  .contact {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px; /* identical to box height, or 137% */
    text-align: center;

    color: ${({ theme }) => theme.colors.charcoal};
    a {
      color: ${({ theme }) => theme.colors.charcoal};
    }
  }
`;

function NoMatch(props) {
  const location = useLocation();
  const client = useApolloClient();

  useEffect(() => {
    client.mutate({
      mutation: LOG_404,
      variables: {
        url: location.pathname
      },
      onError: e => {
        console.log('e', e);
      }
    });
  }, []);

  return (
    <Wrapper>
      <h3 className="notfound ">Page not found!</h3>
      <ButtonLargeWhite>
        <StyledLink to="/" aria-label="The Inside">
          Return to Homepage
        </StyledLink>
      </ButtonLargeWhite>
      <p className="contact">
        Or contact support at{' '}
        <a href="mailto:hi@theinside.com">hi@theinside.com</a>
      </p>
    </Wrapper>
  );
}

export default NoMatch;

export const LOG_404 = gql`
  mutation log404($url: String!) {
    log404(url: $url) {
      success
      message
    }
  }
`;
